import { css, secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';

import { OEText } from '../../atoms/oe-text/oe-text';

export type CalendarLegendProps = {
  activityRegisteredLabel: string;
  todayLabel: string;
};
export const CalendarLegend = ({
  activityRegisteredLabel,
  todayLabel,
}: CalendarLegendProps) => (
  <Container>
    <Row>
      <ActivityCircle />
      <LegendText>{activityRegisteredLabel}</LegendText>
    </Row>
    <Row>
      <TodayCircle />
      <LegendText>{todayLabel}</LegendText>
    </Row>
  </Container>
);

const rowStyle = css`
  flex-direction: row;
  align-items: center;
`;

const Container = styled.View`
  ${rowStyle}
  justify-content: space-between;
  padding: 12px;
`;

const Row = styled.View`
  ${rowStyle};
`;

const LegendText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.black,
  fontFamily: secondaryFontFamily,
  fontSize: 14,
}))`
  margin-left: 6px;
`;

const CIRCLE_SIZE = 18;

const Circle = styled.View`
  width: ${CIRCLE_SIZE}px;
  height: ${CIRCLE_SIZE}px;
  border-radius: ${CIRCLE_SIZE / 2}px;
`;

const ActivityCircle = styled(Circle)`
  background-color: ${({ theme }) => theme.color.olive};
`;

const TodayCircle = styled(Circle)`
  border-width: 1px;
  border-color: ${({ theme }) => theme.color.error};
`;

export default memo(CalendarLegend);
